import React from 'react'
import moment from 'moment';
import { MdOutlineRadioButtonChecked } from 'react-icons/md';

const TimeLine = (props) => {

    let { timeLineArray, documentFormate = false } = props;

    return (
        <>
            <div className='__timLineEw'>
                {timeLineArray?.length > 0 ?
                    timeLineArray?.map((item, index) => {
                        return (
                            <>
                                {documentFormate ?
                                    <div className='__timLineInnr' key={index}>
                                        <span className='__bulletIcon'><MdOutlineRadioButtonChecked /></span>
                                        <p>
                                            {item?.date_time ? moment(item?.date_time).format('DD MMM YYYY') : ''} {item?.date_time ? '|' : ''} {item?.date_time ? moment(item?.date_time).format('hh:mm A') : ''}
                                            <span> {item?.title ? item?.title : '-'} | Document Number {item?.document_no ? item?.document_no : '-'} </span>
                                            <span> Expiry Date {item?.expiry_date ? moment(item?.expiry_date).format('DD MMM YYYY') : '-'} </span>
                                            <span> User {item?.created_by?.name ? item?.created_by?.name : '-'} </span>
                                        </p>
                                    </div>
                                    :
                                    <div className='__timLineInnr' key={index}>
                                        <span className='__bulletIcon'><MdOutlineRadioButtonChecked /></span>
                                        <p>
                                            {item?.title ? item?.title : '-'}
                                            <span>{item?.date_time ? moment(item?.date_time).format('DD MMM YYYY') : ''} {item?.date_time ? '|' : ''} {item?.date_time ? moment(item?.date_time).format('hh:mm A') : ''} | User {item?.created_by?.name ? item?.created_by?.name : '-'}</span>
                                            <span> Eway Bill No. {item?.ewb_no ? item?.ewb_no : '-'} | Start Date : {item?.eway_bill_date ? moment(item?.eway_bill_date).format('DD MMM YYYY') : ''} | End Date : {item?.eway_expiry_date ? moment(item?.eway_expiry_date).format('DD MMM YYYY') : ''} </span>
                                        </p>
                                    </div>
                                }
                            </>
                        )
                    })
                    :
                    'No data found'
                }
            </div>
        </>
    )
}

export default React.memo(TimeLine);